module.exports = __webpack_public_path__ + "static/media/confirmation-modal-header.ffa4395b.png";